<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="6" class="text-start">
                                <strong>Origin Group Master</strong>
                            </b-col>
                            <b-col md="6" class="text-right">
                                <b-button variant="primary" size="sm" @click="add()"><i class="fa fa-plus" aria-hidden="true"></i>
                                    ADD Origin Group</b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="search()"><i class="fa fa-search" aria-hidden="true"></i> Search</b-button>&nbsp;
                                <b-button variant="primary" size="sm" @click="restclear()"><i class="fa fa-search" aria-hidden="true"></i> Reset Search Filter</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-if="add_grouporigin">
                        <h4>Add Origin Group Master</h4>
                        <hr> <br>
                        <b-form @submit.prevent="validateForm('form-1')"
                        data-vv-scope="form-1">
                            <b-row>
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>Client Name <span style="color: red;">*</span></b>
                                        <v-select :options="clientname" v-model="customer.clientname" placeholder="Select Client Name" class="mt-2" v-validate="'required'" name="Client Name"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Client Name'),
                                        }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Client Name')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Client Name')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Client Name") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>Client Service <span style="color: red;">*</span></b>
                                        <v-select :options="clientservies" v-model="customer.clientservice" placeholder="Select Client Service"  name="Client Service"  class="mt-2" v-validate="'required'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Client Service'),
                                        }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Client Service')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Client Service')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Client Service") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4" class="mb-3">
                                    <!-- <b-form-group>
                                        <b>Origin State<span style="color: red;">*</span></b>
                                        <b-form-input v-model="customer.origin_state" name="Origin State" placeholder="Select Origin State" class="mt-2" v-validate="'required|alpha_spaces'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Origin State'),
                                        }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Origin State')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Origin State')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Origin State") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group> -->
                                    <b-form-group>
                                        <label><b>Origin State</b> <span style="color:red;"> *</span></label>
                                        <v-select name="Origin State" v-model="customer.origin_state" @input="selectstate('city',customer.origin_state)" 
                                        placeholder="Select Origin State" :options="StateList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin State'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Origin State')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Origin State')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Origin State") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col md="4" class="mb-3">
                                    <!-- <b-form-group>
                                        <b>Origin City<span style="color: red;">*</span></b>
                                        <b-form-input v-model="customer.origincity" placeholder="Select Origin City" class="mt-2"  name="Origin City" v-validate="'required|alpha_spaces'"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Origin City'),
                                        }"></b-form-input>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Origin City')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Origin City')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Origin City") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group> -->
                                    <b-form-group>
                                        <label><b>Origin City</b> <span style="color:red;">  *</span></label>
                                        <v-select name="Origin City" v-model="customer.origincity" @input="selectcity('pincode',customer.origin_state,customer.origincity)" :disabled="!customer.origin_state"
                                        placeholder="Select Origin City" :options="CityList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Origin City'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Origin City')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Origin City')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Origin City") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                        
                                <b-col md="4" class="mb-3">
                                    <b-form-group>
                                        <b>Group Name <span style="color: red;">*</span></b>
                                        <b-form-input v-model.trim="customer.groupname" placeholder="Group Name" class="mt-2" v-validate="'required'" name="Group Name"
                                        :class="{ input: true, 'is-invalid': errors.has('form-1.Group Name'),
                                        }"/>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Group Name')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Group Name')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Group Name") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <div class="col-md-4">
                                    <!-- <b-form-group>
                                        <label><b>Group Pin-code</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input name="groupincode" v-model="customer.groupincode" placeholder="Group pin-code" maxlength="6" class="italic-placeholder" v-validate="'required|digits:6'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.groupincode'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('groupincode')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.groupincode')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.groupincode") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group> -->

                                    <b-form-group>
                                        <label><b>Group Pin-code</b> <span style="color:red;"> *</span></label>
                                        <v-select name="Group Pin-code" v-model.trim="customer.groupincode" :disabled="!customer.origincity"
                                        placeholder="Select Group Pin-code" :options="PincodeList" v-validate="'required'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Group Pin-code'),
                                            }"></v-select>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Group Pin-code')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Group Pin-code')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Group Pin-code") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group>
                                        <label><b>Thresh Hold Distance</b> <span style="color:red;"> *</span></label>
                                        <b-input-group>
                                            <b-form-input placeholder="Thresh Hold Distance" name="Thresh Hold Distance" v-model.number="customer.threshholddist" class="italic-placeholder" v-validate="'required|decimal:3'"
                                            :class="{ input: true, 'is-invalid': errors.has('form-1.Thresh Hold Distance'),
                                            }"></b-form-input>
                                        </b-input-group>
                                        <b-input-group class="mb-3">
                                            <span class="icon has-text-warning">
                                            <i
                                                class="fa fa-warning"
                                                v-show="errors.has('Thresh Hold Distance')"
                                            ></i>
                                            </span>
                                            <span
                                            style="width:240px"
                                            v-show="errors.has('form-1.Thresh Hold Distance')"
                                            class="help text-danger"
                                            >{{ errors.first("form-1.Thresh Hold Distance") }}</span
                                            >
                                        </b-input-group>
                                    </b-form-group>
                                </div>   
                                <b-col md="4" class="mt-4">
                                    <b-button variant="primary" size="md" type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Save</b-button> &nbsp;
                                    <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                        <br>
                    </div>

                    <div v-if="search_grouporigin">
                        <h4>Search Origin</h4>
                        <hr> <br>
                        <b-row>
                            <b-col md="4">
                                <b>Origin Group Name</b>&nbsp;
                                <b-form-input type="text" class="mt-2" v-model.trim="origngroupname" placeholder="Origin Group Name"/>
                            </b-col>
                            <b-col md="4">
                                <b>Client Service</b>
                                <v-select :options="clientservies" v-model="selectoriginservice" placeholder="Select Origin City" class="mt-2"></v-select>
                            </b-col>
                            <b-col md="4">
                                <b>Origin City</b>
                                <b-form-input v-model.trim="selectorigincity" placeholder="Select Origin City" class="mt-2"></b-form-input>
                            </b-col>
                            <b-col md="12" class="mt-4 text-right">
                                <b-button variant="primary" size="md" @click="origingroupmasterlist(pageNum)"> <i class="fa fa-search" aria-hidden="true"></i> Search</b-button> &nbsp;
                                <b-button variant="danger" @click="clear()"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                            </b-col>
                        </b-row>
                        <br><br>
                    </div>

                    <div>
                        <b-row>
                            <b-col md="12" class="text-right">
                                <b text-variant="red">Total Records :<span style="color: red;"> {{totalRows}}</span></b>
                            </b-col>
                            <b-col md="12">
                                <b-table show-empty responsive :items="items" :fields="fields" :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy">
                                    <div slot="table-busy" class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>  
                                    <template slot="sno" slot-scope="row">
                                        <div>
                                            {{ row.index+1 }}
                                        </div>
                                    </template>
                                    <template slot="allocated_source" slot-scope="row">
                                        <div>
                                            <b-button size="sm" @click="allocatemodelopen(row.item)"><i class="fa fa-eye" ></i></b-button>
                                        </div>
                                    </template>
                                    <template slot="action" slot-scope="row">
                                        <div>
                                            <b-button size="sm" @click="editorigingrmodelopen(row.item)"><i class="fa fa-pencil" ></i></b-button>
                                        </div>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col sm="12" class="text-right">
                          <br>
                               <p style="margin-top: 5px;"> <b>Total Records :<span style="color:red;"> {{totalRows}}</span></b> </p>
                        </b-col>
                        <b-col md="12" class="my-1" >
                            <paginate 
                            v-model="pageNum"
                                :page-count="noofpages"
                                :page-range="10"
                                :margin-pages="2"
                                :click-handler="clickCallback"
                                :prev-text="'Prev'"
                                :next-text="'Next'"
                                :container-class="'pagination'"
                                :page-class="'page-item'">
                            </paginate>
                        </b-col>   
                    </b-row> 

                    <b-modal title="Edit Origin Group" v-model="showorigingroupmodel" @ok="showorigingroupmodel=false" hide-footer size="lg">
                        <b-card>
                            <b-form
                            @submit.prevent="validateForm1('form-2')"
                            data-vv-scope="form-2">
                                <b-row>
                                    <div id="overlaymodel" >
                                        <div class="modelloader"></div>
                                      </div>
                                      <div id="listloader" v-if="listloader">
                                        <div class="listloader"></div>
                                    </div>
                                    <b-col md="6">
                                        <b-form-group>
                                            <label><b>Group Name</b> <span style="color:red;">  *</span></label>
                                            <b-form-input type="text" class="mt-2" v-model.trim="groupname"  name="Group Name" v-validate="'required'" placeholder="Group Name"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.Group Name'),
                                            }" disabled/>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Group Name')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-2.Group Name')"
                                                class="help text-danger"
                                                >{{ errors.first("form-2.Group Name") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <!-- <b-form-group>
                                            <b>Source City</b>
                                            <b-form-input v-model="user.sourcecity" placeholder="Select Origin City" class="mt-2" v-validate="'required'" name="Source City"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.Source City'),
                                            }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Source City')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-2.Source City')"
                                                class="help text-danger"
                                                >{{ errors.first("form-2.Source City") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        <b-form-group>
                                            <label><b>Source City</b> <span style="color:red;">  *</span></label>
                                            <v-select name="Source City" v-model="user.sourcecity" 
                                            placeholder="Select Source City" :options="editAllCityList" @input="getCityWiseVendor()" v-validate="'required'"
                                                :class="{ input: true, 'is-invalid': errors.has('form-1.Source City'),
                                                }"></v-select>
                                                <b-input-group class="mb-3">
                                                    <span class="icon has-text-warning">
                                                    <i
                                                        class="fa fa-warning"
                                                        v-show="errors.has('Source City')"
                                                    ></i>
                                                    </span>
                                                    <span
                                                    style="width:240px"
                                                    v-show="errors.has('form-2.Source City')"
                                                    class="help text-danger"
                                                    >{{ errors.first("form-2.Source City") }}</span
                                                    >
                                                </b-input-group>
                                        </b-form-group>
                                        <!-- <b-form-group>
                                            <b>Source City</b>
                                            <b-form-input v-model="user.sourcecity" placeholder="Select Origin City" class="mt-2" v-validate="'required'" name="Source City"
                                            :class="{ input: true, 'is-invalid': errors.has('form-2.Source City'),
                                            }"></b-form-input>
                                            <b-input-group class="mb-3">
                                                <span class="icon has-text-warning">
                                                <i
                                                    class="fa fa-warning"
                                                    v-show="errors.has('Source City')"
                                                ></i>
                                                </span>
                                                <span
                                                style="width:240px"
                                                v-show="errors.has('form-2.Source City')"
                                                class="help text-danger"
                                                >{{ errors.first("form-2.Source City") }}</span
                                                >
                                            </b-input-group>
                                        </b-form-group> -->
                                        <br>
                                    </b-col>
                                    <b-col md="6">
                                        <label><b>Origin Name</b> <span style="color:red;">  *</span></label>
                                        <div v-if="Sourcelist.length>0">
                                            <b-card style="width: 700px; height: 250px; overflow: scroll;">
                                                <input type="checkbox" @click="checkAll()" v-model="isCheckAll"> &nbsp;
                                                <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">Select All</span>
                                                <ul>
                                                  <li v-for="item in Sourcelist" :key="item.id">
                                                    <input class="parentAWBcheckbox" type="checkbox"  v-bind:value="item.destinationpincode" @change="multiselectdesign($event,item)"  v-model='checkedpincode' />
                                                    &nbsp;&nbsp;
                                                    <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">
                                                      {{ item.destination_name }} ({{ item.destinationcity }} - {{ item.userid }} {{item.distance ? '-' : ''  }} {{ item.distance }} {{ item.distance ? 'Km' : '' }})
                                                    </span>
                                                  </li>
                                                </ul>
                                            </b-card>
                                        </div>
                                        <div v-else>
                                            <br>
                                            <h5><pre>No Records Found</pre></h5>
                                        </div>
                                    </b-col>
                                    <b-col md="12" class="text-right">
                                        <b-button variant="primary" size="md" type="submit"> <i class="fa fa-check-circle-o" aria-hidden="true"></i> Update</b-button> &nbsp;
                                        <b-button variant="danger" @click="clear('ok')"><i class="fa fa-ban" aria-hidden="true"></i> Clear</b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-card>
                    </b-modal>

                    <b-modal title="Allocated Sources" v-model="showallocatemodel" @ok="showallocatemodel=false" hide-footer size="lg">
                        <b-card>
                            <div id="listloader" v-if="listloader">
                                <div class="listloader"></div>
                            </div>
                            <div v-if="allocatesourcelist.length>0">
                                <ul>
                                    <li v-for="item in allocatesourcelist">
                                        <input type="checkbox" v-model="checkall" disabled>&nbsp;&nbsp;
                                        <span style="font-family: SFMono-Regular, Menlo, Monaco, Consolas; font-size: 17px;">{{ item.destination_name }} ({{ item.destinationcity }} - {{ item.userid }} {{item.distance ? '-' : ''  }} {{ item.distance }} {{ item.distance ? 'Km' : '' }})</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else class="text-center">
                                <h5><pre>No Records Found</pre></h5>
                            </div>
                        </b-card>
                    </b-modal>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";

export default {
    data() {
        return {
            isBusy: false,
            items:[],
            fields:[
                {key:'sno',label:'S.No'},
                {key:'origin_city', label:'Group City'},
                {key:'clientname', label:'Client Name'},
                {key:'origin_group_name', label:'Group Name'},
                {key:'origingroup_id', label:'Group ID'},
                {key:'origin_client_service', label:'Client Service'},
                {key:'allocated_source',label:'Allocated Source'},
                {key:'createdby',label:'Created By'},
                {key:'createddate',label:'Created Date'},
                {key:'lastmodifiedby',label:'Updated By'},
                {key:'lastmodifieddate', label:'Updated On'},
                {key:'action',label:'Action'}
            ],
            totalRows :0,
            clientnamelist: [],
            clientname :[],


            //add start
            add_grouporigin:false,
            customer:{},
            clientservies: ["B2B"],
            //add end 


            //search start
            search_grouporigin:false,
            origngroupname:'',
            selectoriginservice :'',
            selectorigincity :'',
            //search end

            //pagination 
            currentPage: 1,
            perPage:  20,
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            noofpages:'',
            pageNum:1,
            listingpageno:1,
            //end pagi 

            //edit
            showorigingroupmodel : false,
            user :{},
            origingroup_id :'',
            isCheckAll: false,
            selectedItems: [],
            checkedpincode :[],
            unselectpincode : [],
            groupname : '',
            editCityList : [],
            //edit end 

            //Source
            showallocatemodel:false,
            Sourcelist:[],
            checkall : true,
            allocatesourcelist :[],
            //Source end

            //country
            Obj :{},
            country:["India"],
            item_state :[],
            StateList:[],
            item_city : [],
            CityList : [],
            item_pincode : [],
            PincodeList : [],
            originstate :'',
            getOriginGroupData:{},
            allCity:[],
            editAllCityList:[]
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.allclientlist()
        this.origingroupmasterlist(this.pageNum)
        this.getStateList('country')
    },

    methods: {
        add(){
            this.clear()
            // this.allclientlist()
            // this.getStateList('country')
            this.search_grouporigin=false;
            this.add_grouporigin=!this.add_grouporigin
        },

        search(){
            this.add_grouporigin=false;
            this.search_grouporigin=!this.search_grouporigin
            this.clear()
        },

        restclear(){
            this.search_grouporigin=false;
            this.add_grouporigin=false;
            this.pageNum=1;
            this.customer={};
            this.origngroupname= '';
            this.selectoriginservice='';
            this.selectorigincity='';
            this.user= {};
            this.StateList = [];
            this.item_city = [];
            this.CityList = [];
            this.item_pincode = [];
            this.PincodeList = [];
            this.allCity=[];
            this.origingroupmasterlist(this.pageNum);
            this.getStateList('country')
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist() 
            this.checkedpincode =[];
            this.isCheckAll=false;
        },

        clear(value){
            this.pageNum=1;
            this.customer={};
            this.origngroupname= '';
            this.selectoriginservice='';
            this.selectorigincity='';
            this.user= {};
            this.StateList = [];
            this.item_city = [];
            this.CityList = [];
            this.item_pincode = [];
            this.PincodeList = [];
            this.allCity=[];
            this.origingroupmasterlist(this.pageNum);
            this.getStateList('country')
            this.clientnamelist =[];
            this.clientname =[];
            this.allclientlist()   
            if (value=='ok') {
                this.getStateList('city',this.originstate)
            }
            this.checkedpincode =[];
            this.isCheckAll=false;
        },

        allclientlist(){
            const Obj = {}
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getallclientlist`,Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    this.clientnamelist = result.body.returnvalue;

                    this.clientnamelist.forEach(value => {
                        var client = {
                            key:value.clientmasterid,
                            label:value.clientname
                        }
                        this.clientname.push(client)
                        if (value.clientmasterid==27 && value.clientname=="Firstcry") {
                            this.customer.clientname = client;
                        }
                    });
            
                } else {
                    this.clientnamelist =[];
                    this.clientname =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        clickCallback (pageNum){
            this.listingpageno = pageNum;
            this.origingroupmasterlist(pageNum);
        },

        origingroupmasterlist(pageNum){
            this.isBusy=true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                sysusermasterid :`${userInfo.sysusermasterid}`,
                page_no : pageNum,
                origin_group_name : this.origngroupname.trim(),
                origin_client_service :this.selectoriginservice,
                origin_city : this.selectorigincity.trim(),
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getorigingroupmasterList`,Obj)
            .then((result) => {
                this.isBusy=false;
                if (result.body.returnmsg === "Successful") {
                    this.items = result.body.returnvalue;
                    this.totalRows = result.body.totalcount;
                    this.noofpages=parseInt(this.totalRows)/20;
                    this.noofpages=Math.ceil( this.noofpages);
            
                } else {
                    this.items =[];
                    this.totalRows =0;
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.addgrouporiginmasterinfo();
                }
            });
        },

        addgrouporiginmasterinfo(){
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            const Obj = {
                sysusermasterid : `${userInfo.sysusermasterid}`,
                client_id : `${this.customer.clientname==null?'':this.customer.clientname.key}`,
                origin_client_service : this.customer.clientservice,
                origin_state : this.customer.origin_state,
                origin_city : this.customer.origincity,
                origin_group_name : this.customer.groupname,
                group_pincode : this.customer.groupincode,
                threshhold_distance : `${this.customer.threshholddist}`,
                createdby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            }
            console.log("Obj",Obj)
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addorigingroupmasterinfo`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                });
                this.add_grouporigin = false;
                this.origingroupmasterlist(this.pageNum)
                this.clear();
                this.customer = {};
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        editorigingrmodelopen(data){
            this.checkedpincode = []
            this.unselectpincode = []
            this.Sourcelist = []
            this.editCityList = []
            this.origingroup_id='';
            this.add_grouporigin=false;
            this.search_grouporigin=false;
            this.groupname = data.origin_group_name;
            this.user.sourcecity = data.origin_city;
            this.originstate = data.origin_state;
            this.getOriginGroupData=data;
            this.getAllCity();
            // if (data.origin_state!=null && data.origin_state!=undefined) {
            //     this.getStateList('city',data.origin_state)
            // }
            this.origingroup_id = data.origingroup_id;
            this.showorigingroupmodel=!this.showorigingroupmodel;
            this.Originsourcelist(data)
        },

        validateForm1(scope) {
            this.$validator.validateAll(scope).then((result) => {
                console.log("-----------",result)
                if (result) {
                    this.updateOrigingroup();
                }
            });
        },

        updateOrigingroup(){
            document.getElementById("overlaymodel").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            // if (this.checkedpincode.length==0) {
            //     this.$fire({
            //             text: 'Please Select AT Least One origin Name',
            //             type: "error",
            //             timer: 30000,
            //         });
            //         document.getElementById("overlaymodel").style.display = "none";
            //         return false;
            // }
            const Obj = {
                sysusermasterid : `${userInfo.sysusermasterid}`,
                origingroup_id :  `${this.origingroup_id}`,
                // origin_group_name :  this.user.groupname,
                origin_city : this.user.sourcecity,
                is_check : this.checkedpincode,
                is_uncheck :  this.unselectpincode,
                lastmodifiedby : `${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/editorigingroup`,Obj)
            .then((result) => {
                console.log(result);
                document.getElementById("overlaymodel").style.display = "none";
                if (result.body.returnmsg === "Successful") {
                this.$fire({
                    text: 'Origin Group Master Edited Successfully',
                    type: "success",
                    timer: 30000,
                });
                this.showorigingroupmodel = false;
                this.origingroupmasterlist(this.pageNum)
                this.clear();
                this.user = {};
                this.clientnamelist =[];
                this.clientname =[];
                } else {
                    this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        allocatemodelopen(data){
            this.Sourcelist = []
            this.checkedpincode = []
            this.allocatesourcelist = []
            this.showallocatemodel =! this.showallocatemodel;
            this.Originsourcelist(data)
        },


        Originsourcelist (data){
            this.isCheckAll = false
            this.listloader = true;
            this.Sourcelist = []
            this.checkedpincode = []
            this.unselectpincode = []
            this.allocatesourcelist = []
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            const Obj = {
                sysusermasterid : `${userInfo.sysusermasterid}`,
                origingroup_id : `${data.origingroup_id}`,
            }
            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getAllocatedOriginList`,Obj)
            .then((result) => {
                this.listloader = false;
                if (result.body.returnmsg === "Successful") {
                    this.Sourcelist = result.body.returnvalue;
                    for (let i = 0; i <  this.Sourcelist.length; i++) {
                        if (this.Sourcelist[i].is_check=='Yes') {
                            this.checkedpincode.push(this.Sourcelist[i].destinationpincode);
                        }
                        
                    }

                    if (this.checkedpincode.length==this.Sourcelist.length) {
                        this.isCheckAll = true
                        console.log("--------")
                    }
                    else{
                        this.isCheckAll = false
                    }

                    for (let i = 0; i <  this.Sourcelist.length; i++) {
                        if (this.Sourcelist[i].is_check=='Yes') {
                            this.allocatesourcelist.push(this.Sourcelist[i]);
                        }
                        
                    }

                } else {
                    this.Sourcelist =[];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        checkAll: function(){

            this.isCheckAll = !this.isCheckAll;
            this.checkedpincode = [];
            this.unselectpincode = [];
            
            if(this.isCheckAll){ // Check all

                for (var key in this.Sourcelist) {
                    this.checkedpincode.push(this.Sourcelist[key].destinationpincode);
                    this.unselectpincode = [];
                }
            }
            else{
                for (var key in this.Sourcelist) {
                    this.unselectpincode.push(this.Sourcelist[key].destinationpincode);
                    this.checkedpincode = [];
                }
            }
        },

        multiselectdesign(e,value){

            if (e.target.checked==false) {
                this.unselectpincode.push(value.destinationpincode)
            }
    
            if (e.target.checked==true) {
                this.unselectpincode = this.unselectpincode.filter(code => code !== value.destinationpincode)
            }

            if(this.checkedpincode.length == this.Sourcelist.length){
                console.log("-------------",this.checkedpincode.length,this.Sourcelist.length)
                this.isCheckAll = true;
            }
            else{
                console.log("++++++++++++",this.checkedpincode.length,this.Sourcelist.length)
                this.isCheckAll = false;
            }
        },

        // add Start
        selectcountry(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            // if (value=='state') {
            //     this.getStateList('state',country)
            // }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.origin_state='';
                this.customer.origincity='';
                this.customer.groupincode='';
            }
        },
        
        selectstate(value,state){
            if (value=='city') {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.origincity='';
                this.customer.groupincode='';
                this.getStateList('city',state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.origin_state='';
                this.customer.origincity='';
                this.customer.groupincode='';
                this.getStateList('country')
            }
        },

        selectcity(value,state,city){
            if (value=='pincode') {
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.groupincode='';
                this.getStateList('pincode',state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.customer.origincity='';
                this.customer.groupincode='';
                this.getStateList('city',state)
            }
        },
        // add end

        //edit start

        editselectcountry(value,data){
            if (value=='country') {
                this.getStateList('country')
            }
            // if (value=='state') {
            //     this.getStateList('state',country)
            // }
            if (data==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.origin_state='';
                this.user.origincity='';
                this.user.groupincode='';
            }
        },
        
        editselectstate(value,state){
            if (value=='city') {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.origincity='';
                this.user.groupincode='';
                this.getStateList('city',state)
            }
            if (state==null) {
                this.item_state = [];
                this.StateList = [];
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.origin_state='';
                this.user.origincity='';
                this.user.groupincode='';
            }
        },

        editselectcity(value,state,city){
            if (value=='pincode') {
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.groupincode='';
                this.getStateList('pincode',state,city)
            }
            if (city==null) {
                this.item_city = [];
                this.CityList = [];
                this.item_pincode = [];
                this.PincodeList = [];
                this.user.origincity='';
                this.user.groupincode='';
            }
        },

        //edit end
        getStateList(value,state,city){
            this.editCityList = []
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            if (value=='country') {
                this.Obj = {
                    country : "",
                    state : "",
                    city : "",
                    pincode : ""
                }
            }

            // if (value=='state') {
            //     this.Obj = {
            //         country : country,
            //         state : "",
            //         city : "",
            //         pincode : ""
            //     }
            // }

            if (value=='city') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : "",
                    pincode : ""
                }
            }

            if (value=='pincode') {
                this.Obj = {
                    country : "",
                    state : state,
                    city : city,
                    pincode : ""
                }
            }

            // return false;
            this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/getStateCityPincodes`,this.Obj)
            .then((result) => {
                console.log("result",result)
                if (result.body.returnmsg === "Successful") {
                    if (value=='country') {
                        this.item_state = [];
                        this.StateList = [];
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_state = result.body.returnvalue;
                        this.item_state.forEach(value => {
                            this.StateList.push(value.state)
                        });
                    }

                    if (value=='city') {
                        this.item_city = [];
                        this.CityList = [];
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_city = result.body.returnvalue;
                        this.item_city.forEach(value => {
                            this.CityList.push(value.city)
                            this.editCityList.push(value.city)
                        });
                    }

                    if (value=='pincode') {
                        this.item_pincode = [];
                        this.PincodeList = [];
                        this.item_pincode = result.body.returnvalue;
                        this.item_pincode.forEach(value => {
                            this.PincodeList.push(value.pincode)
                        });
                    }
                } 
                else {
                    this.item_state = [];
                    this.StateList = [];
                    this.item_city = [];
                    this.CityList = [];
                    this.item_pincode = [];
                    this.PincodeList = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },
        getCityWiseVendor(){
            // alert('inn');
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            let payloadObj={
                origin_city:`${this.user.sourcecity}`,
                origingroup_id:`${this.getOriginGroupData.origingroup_id}`,
                lastmodifiedby:`${userInfo.userfirstname + ' ' + userInfo.userlastname}`,
                group_pincode:`${this.getOriginGroupData.group_pincode}`,
            }
            console.log('----------------------->',payloadObj)
            // return false;
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/insertOriginCityDistanceAndVendors`,payloadObj).then((response)=>{
             console.log("response------------------>",response)
             if(response.body.returnmsg=='Successful'){
                this.Originsourcelist(this.getOriginGroupData)
                this.$fire({
                        text: response.body.returnvalue,
                        type: "success",
                        timer: 30000,
                    });
                   
             }else{
                this.$fire({
                        text: response.body.returnvalue,
                        type: "error",
                        timer: 30000,
                    });
             }
            }).catch((err)=>{
                console.log("Error------------>",err)
            })
        },
        getAllCity(){
            // alert("inn");
          this.item_city = [];
          this.CityList = [];
          this.editAllCityList=[];
          let cityObj={};
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/apiToGetAllCity`,cityObj).then((response)=>{
            if(response.body.returnmsg=='Successful'){
              this.allCity=response.body.returnvalue;
              this.allCity.forEach(value=>{
                this.editAllCityList.push(value.city)
              })
            }else{
                this.$fire({
                    text: response.body.returnvalue,
                    type: "error",
                    timer: 30000,
                });
            }
          }).catch((err)=>{
            console.log("Error------------>",err)
          })
        }
    },
}
</script>
